import { __exports as fetcher } from "../../../../../../_virtual/fetcher.js";
import require$$1 from "../../../../../../_virtual/experiment-core.esm.js";
import { __require as requireVersion } from "../../gen/version.js";
import { __require as requireHttp } from "../transport/http.js";
import { __require as requireConfig } from "../types/config.js";
import { __require as requireLoglevel } from "../types/loglevel.js";
import { __require as requireLogger } from "../util/logger.js";
var hasRequiredFetcher;
function requireFetcher() {
  if (hasRequiredFetcher) return fetcher;
  hasRequiredFetcher = 1;
  var __awaiter = fetcher && fetcher.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  Object.defineProperty(fetcher, "__esModule", { value: true });
  fetcher.FlagConfigFetcher = void 0;
  const experiment_core_1 = require$$1;
  const version_1 = requireVersion();
  const http_1 = requireHttp();
  const config_1 = requireConfig();
  const loglevel_1 = requireLoglevel();
  const logger_1 = requireLogger();
  const FLAG_CONFIG_TIMEOUT = 5e3;
  class FlagConfigFetcher {
    constructor(apiKey, httpClient, serverUrl = config_1.LocalEvaluationDefaults.serverUrl, logLevel = loglevel_1.LogLevel.Error, loggerProvider = new logger_1.ConsoleLogger()) {
      this.apiKey = apiKey;
      this.serverUrl = serverUrl;
      this.flagApi = new experiment_core_1.SdkFlagApi(apiKey, serverUrl, new http_1.WrapperClient(httpClient));
      this.logger = new logger_1.AmplitudeLogger(logLevel, loggerProvider);
    }
    /**
     * Fetch local evaluation mode flag configs from the Experiment API server.
     * These flag configs can be used to perform local evaluation.
     *
     * @returns The local evaluation mode flag configs for the initialized
     * environment
     */
    fetch() {
      return __awaiter(this, void 0, void 0, function* () {
        const flags = this.flagApi.getFlags({
          libraryName: "experiment-node-server",
          libraryVersion: version_1.version,
          evaluationMode: "local",
          timeoutMillis: FLAG_CONFIG_TIMEOUT
        });
        if (this.receiver) {
          this.receiver(JSON.stringify(flags));
        }
        return flags;
      });
    }
    setRawReceiver(rawReceiver) {
      this.receiver = rawReceiver;
    }
  }
  fetcher.FlagConfigFetcher = FlagConfigFetcher;
  return fetcher;
}
export {
  requireFetcher as __require
};
//# sourceMappingURL=fetcher.js.map
